import React, { useState, Fragment, Component } from 'react'
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Badge,
    Input,
    InputGroup,
    Label,
    Button,
    Spinner
} from 'reactstrap'
import PerhitunganBloc from "../Blocs/PerhitunganBloc"
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

/**
 * IndexComponent
 * Replicates the "Master Konfigurasi 2 Skema Pembobotan Peran 360°" UI
 * using only Reactstrap components + default Bootstrap 5 utility classes.
 * No custom CSS is used anywhere in this file.
 */
class IndexComponent extends Component
{

    perhitunganBloc = new PerhitunganBloc();

    constructor(props) {
        super(props)

        this.state = {
            loadingContent: true,
            overall: {
                jpt: [
                    { key: 'atasan', label: 'Atasan (JPT Madya/Deputi)', value: 85, colorClass: 'text-primary' },
                    { key: 'rekan', label: 'Rekan / Sejawat (Sesama JPT)', value: 0, colorClass: 'text-success' },
                    { key: 'bawahan', label: 'Bawahan (Staff Unit & Ahli Madya)', value: 15, colorClass: 'text-warning', highlight: true },
                ],
                staff: [
                    { key: 'atasan', label: 'Atasan (JPT Pratama / Kabiro)', value: 75, colorClass: 'text-primary' },
                    { key: 'rekan', label: 'Rekan / Sejawat (Sesama Staff/Ahli Madya)', value: 25, colorClass: 'text-success' },
                    { key: 'bawahan', label: 'Bawahan (Boleh diisi 0%)', value: 0, colorClass: 'text-muted', disabled: false },
                ],
            },
            berakhlak: {
                jpt: [
                    { key: 'atasan', label: 'Atasan BerAKHLAK (%)', value: 85, colorClass: 'text-primary' },
                    { key: 'sejawat', label: 'Sejawat BerAKHLAK (%)', value: 0, colorClass: 'text-success' },
                    { key: 'bawahan', label: 'Bawahan BerAKHLAK (%)', value: 15, colorClass: 'text-warning', highlight: true },
                ],
                staff: [
                    { key: 'atasan', label: 'Atasan BerAKHLAK (%)', value: 75, colorClass: 'text-primary' },
                    { key: 'bawahan', label: 'Bawahan BerAKHLAK (%)', value: 0, colorClass: 'text-muted', disabled: true },
                ],
            },
        }

        this.handleChangeRow = this.handleChangeRow.bind(this)
        this.handleSave = this.handleSave.bind(this)
    }

    loadCompnent = async () => {
        await this.perhitunganBloc.fetchList({})
    }

    componentDidMount() {

        this.loadCompnent()

        this.perhitunganBloc.perhitunganSubmitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.loadCompnent()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.perhitunganBloc.perhitunganListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingContent: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingContent: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const setting = response.setting
                    this.setState({
                        loadingContent: false,
                        overall: {
                            jpt: [
                                { key: 'atasan', label: 'Atasan (JPT Madya/Deputi)', value: parseFloat(setting?.value_all_atasan_leader), colorClass: 'text-primary' },
                                { key: 'rekan', label: 'Rekan / Sejawat (Sesama JPT)', value: parseFloat(setting?.value_all_rekan_leader), colorClass: 'text-success' },
                                { key: 'bawahan', label: 'Bawahan (Staff Unit & Ahli Madya)', value: parseFloat(setting?.value_all_rekan_leader), colorClass: 'text-warning', highlight: true },
                            ],
                            staff: [
                                { key: 'atasan', label: 'Atasan (JPT Pratama / Kabiro)', value: parseFloat(setting?.value_all_atasan_member), colorClass: 'text-primary' },
                                { key: 'rekan', label: 'Rekan / Sejawat (Sesama Staff/Ahli Madya)', value: parseFloat(setting?.value_all_rekan_member), colorClass: 'text-success' },
                                { key: 'bawahan', label: 'Bawahan (Boleh diisi 0%)', value: parseFloat(setting?.value_all_bawahan_member), colorClass: 'text-muted', disabled: false },
                            ],
                        },
                        berakhlak: {
                            jpt: [
                                { key: 'atasan', label: 'Atasan BerAKHLAK (%)', value: parseFloat(setting?.value_berakhlak_atasan_leader), colorClass: 'text-primary' },
                                { key: 'sejawat', label: 'Sejawat BerAKHLAK (%)', value: parseFloat(setting?.value_berakhlak_rekan_leader), colorClass: 'text-success' },
                                { key: 'bawahan', label: 'Bawahan BerAKHLAK (%)', value: parseFloat(setting?.value_berakhlak_bawahan_leader), colorClass: 'text-warning', highlight: true },
                            ],
                            staff: [
                                { key: 'atasan', label: 'Atasan BerAKHLAK (%)', value: parseFloat(setting?.value_berakhlak_atasan_member), colorClass: 'text-primary' },
                                { key: 'bawahan', label: 'Bawahan BerAKHLAK (%)', value: parseFloat(setting?.value_berakhlak_atasan_bawahan), colorClass: 'text-muted', disabled: false },
                            ],
                        },
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount(){
        this.perhitunganBloc.perhitunganListChannel.unsubscribe()
        this.perhitunganBloc.perhitunganSubmitChannel.unsubscribe()
    }

     confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    // sectionKey: 'overall' | 'berakhlak'
    // schemeKey: 'jpt' | 'staff'
    handleChangeRow(sectionKey, schemeKey, rowKey, newValue) {
        this.setState((prevState) => {
            const section = prevState[sectionKey]
            const updatedRows = section[schemeKey].map((r) =>
                r.key === rowKey ? { ...r, value: newValue } : r
            )

            return {
                [sectionKey]: {
                    ...section,
                    [schemeKey]: updatedRows,
                },
            }
        })
    }

    submitData = async () => {
        const { overall, berakhlak } = this.state
        const form = new FormData();  
        form.append("value_all_atasan_leader", String(overall.jpt.find(x => x.key === 'atasan')?.value));
        form.append("value_all_rekan_leader", String(overall.jpt.find(x => x.key === 'rekan')?.value));
        form.append("value_all_bawahan_leader",String(overall.jpt.find(x => x.key === 'bawahan')?.value));
        form.append("value_all_atasan_member", String(overall.staff.find(x => x.key === 'atasan')?.value));
        form.append("value_all_rekan_member", String(overall.staff.find(x => x.key === 'rekan')?.value));
        form.append("value_all_bawahan_member", String(overall.staff.find(x => x.key === 'bawahan')?.value));;
        form.append("value_berakhlak_atasan_leader", String(berakhlak.jpt.find(x => x.key === 'atasan')?.value));
        form.append("value_berakhlak_rekan_leader", String(berakhlak.jpt.find(x => x.key === 'sejawat')?.value));
        form.append("value_berakhlak_bawahan_leader", String(berakhlak.jpt.find(x => x.key === 'bawahan')?.value));
        form.append("value_berakhlak_atasan_member", String(berakhlak.staff.find(x => x.key === 'atasan')?.value));
        form.append("value_berakhlak_atasan_bawahan", String(berakhlak.staff.find(x => x.key === 'bawahan')?.value));
        await this.perhitunganBloc.fetchSubmit(form)
    }

    handleSave() {
        this.setState({
            confirm: true,
        });
    }

    getTotal(rows) {
        return rows.reduce((sum, r) => sum + Number(r.value || 0), 0)
    }

    renderWeightRow(sectionKey, schemeKey, row) {
        return (
            <div key={row.key} className={`mb-3 p-2 rounded ${row.highlight ? 'bg-warning-subtle' : ''}`}>
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <Label className="mb-0 fw-semibold small">{row.label}</Label>
                    <span className={`fw-semibold small ${row.colorClass}`}>{row.value}%</span>
                </div>
                <InputGroup size="sm">
                    <Input
                        type="number"
                        min={0}
                        max={100}
                        value={row.value}
                        disabled={row.disabled}
                        onChange={(e) => this.handleChangeRow(sectionKey, schemeKey, row.key, Number(e.target.value))}
                    />
                </InputGroup>
            </div>
        )
    }

    renderSchemeCard(sectionKey, schemeKey, icon, title, subtitle, rows, borderClass) {
        const total = this.getTotal(rows)

        return (
            <Card className={`h-100 border ${borderClass}`}>
                <CardBody>
                    <div className="d-flex justify-content-between align-items-start mb-1">
                        <h6 className="mb-0">
                            <span className="me-2">{icon}</span>
                            {title}
                        </h6>
                        <Badge color="success" pill className="bg-success-subtle text-success border border-success">
                            Total: {total}%
                        </Badge>
                    </div>
                    <p className="text-muted small mb-3">{subtitle}</p>

                    {rows.map((row) => this.renderWeightRow(sectionKey, schemeKey, row))}
                </CardBody>
            </Card>
        )
    }

    renderMasterSection(sectionKey, icon, headerTitle, headerDesc, headerClass, borderClass) {
        const section = this.state[sectionKey]

        return (
            <div className="mb-4">
                <div className={`p-3 rounded mb-3 ${headerClass}`}>
                    <h6 className="mb-1">
                        <span className="me-2">{icon}</span>
                        {headerTitle}
                    </h6>
                    <p className="mb-0 small text-muted">{headerDesc}</p>
                </div>

                <Row className="g-3">
                    <Col md={6}>
                        {this.renderSchemeCard(
                            sectionKey,
                            'jpt',
                            '👑',
                            '[Skema 1] Pimpinan JPT (Level 4 & 5)',
                            'Khusus JPT Pratama (Direktur/Kabiro) & JPT Madya',
                            section.jpt,
                            borderClass
                        )}
                    </Col>
                    <Col md={6}>
                        {this.renderSchemeCard(
                            sectionKey,
                            'staff',
                            '👥',
                            '[Skema 2] Staff & Fungsional (Level 1–4)',
                            'Khusus Fungsional Ahli Madya & Staff Level 1–3',
                            section.staff,
                            borderClass
                        )}
                    </Col>
                </Row>
            </div>
        )
    }

    render(){
        return (
            <Fragment>
                <Container fluid>
                    { this.state.loadingContent ? <>
                        <div className='card'>
                           <div className='card-body p-5 text-center'>
                             <Spinner size="sm" className="me-1" />
                                Memuat Data...
                           </div>
                        </div>
                    </> : <>
                        {this.renderMasterSection(
                            'overall',
                            '📋',
                            '1. Master Konfigurasi 2 Skema Pembobotan Peran 360° (NILAI KESELURUHAN / OVERALL)',
                            'Digunakan untuk menghitung Nilai Akhir 360° Akumulasi Keseluruhan (seluruh soal kuesioner).',
                            'bg-primary-subtle',
                            'border-primary-subtle'
                        )}

                        {this.renderMasterSection(
                            'berakhlak',
                            '📖',
                            '2. Master Konfigurasi 2 Skema Pembobotan Peran 360° (KHUSUS CORE VALUES BERAKHLAK)',
                            'Digunakan khusus untuk menghitung Nilai Core Values BerAKHLAK 360° (hanya menyaring 7 Nilai Dasar ASN BerAKHLAK).',
                            'bg-success-subtle',
                            'border-success-subtle'
                        )}

                        <div className="d-flex justify-content-end">
                            <Button color="primary" size="lg" onClick={this.handleSave}>
                                💾 Simpan Seluruh Master Bobot (Overall & BerAKHLAK)
                            </Button>
                        </div>
                    </> }
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }

}

export default IndexComponent